import { render } from "./PagePengambilanFormulir.vue?vue&type=template&id=335082b2"
import script from "./PagePengambilanFormulir.vue?vue&type=script&lang=js"
export * from "./PagePengambilanFormulir.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__